import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const ArrowBottomLeftAngleIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M2.34314 5.17169V13.657M2.34314 13.657H10.8284M2.34314 13.657L13.6568 2.34326" stroke={color} strokeLinejoin="round" />
  </Svg>
);

ArrowBottomLeftAngleIcon.displayName = 'ArrowBottomLeftAngleIcon';
